import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CrawlCtx = createContext(null);
const STORE = "mhh_crawl";

export function CrawlProvider({ children }) {
  const [stops, setStops] = useState(() => JSON.parse(localStorage.getItem(STORE) || "[]"));

  useEffect(() => {
    localStorage.setItem(STORE, JSON.stringify(stops));
  }, [stops]);

  const has = useCallback((id) => stops.some((s) => s.id === id), [stops]);

  const toggle = useCallback((venue) => {
    setStops((s) => {
      if (s.some((x) => x.id === venue.id)) return s.filter((x) => x.id !== venue.id);
      if (s.length >= 12) {
        toast.error("A crawl can have up to 12 stops");
        return s;
      }
      toast.success(`${venue.name} added to your bar crawl`);
      return [...s, venue];
    });
  }, []);

  const move = useCallback((i, dir) => {
    setStops((s) => {
      const j = i + dir;
      if (j < 0 || j >= s.length) return s;
      const n = [...s];
      [n[i], n[j]] = [n[j], n[i]];
      return n;
    });
  }, []);

  return (
    <CrawlCtx.Provider value={{ stops, setStops, has, toggle, move, clear: () => setStops([]) }}>{children}</CrawlCtx.Provider>
  );
}

export const useCrawl = () => useContext(CrawlCtx);
